function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 388",
  d: "M48.1 124.26c30.43 0 47.6-25.16 47.6-61.88S78.53.5 48.1.5C17.84.5.5 25.66.5 62.38s17.34 61.88 47.6 61.88zm0-22.95c-15.98 0-24.14-13.77-24.14-38.93s8.16-39.1 24.14-39.1 24.31 13.94 24.31 39.1-8.33 38.93-24.31 38.93zm83.3-98.43l-31.28 11.05 5.78 20.06 22.44-6.29v94.18h23.46v-119z",
  fill: "none",
  stroke: "#3c00dc"
});

function SvgNumber01Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.3,
    height: 124.76,
    viewBox: "0 0 152.3 124.76"
  }, props), _ref);
}

export default SvgNumber01Inline;